import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Typography,
  InputAdornment,
   CircularProgress,
} from "@mui/material";
import {  DecryptSecretFunction } from "../../utils/cryptoFunction";

export default function SecretKeyGate() {
  const [key, setKey] = useState("");
  const [error, setError] = useState("");
  const [showKey, setShowKey] = useState(false);
  const [courseId, setCourseId] = useState("");
  const [courseName, setCourseName] = useState("");
  const [loading, setLoading] = useState(true);
  const SECRETPASS = process.env.REACT_APP_SECERT_KEY;
  const SECRET=DecryptSecretFunction(SECRETPASS);
  const REDIRECT_URL = process.env.REACT_APP_FRONTEND_URL;
  // 🔹 Extract query parameters from URL
  useEffect(() => {
    const search = window.location.search;
  if (!search) return; // agar abhi params hi nahi aaye
   let cname;
  const match = search.match(/coursename=(.*)/);
  if (match && match[1]) {
     cname = decodeURIComponent(match[1]);
   
    }

  const params = new URLSearchParams(search);
  const cid = params.get("courseid");

  // agar dono param mile tabhi set karo aur redirect logic lagao
  if (cid && cname) {
    setCourseId(cid);
    setCourseName(cname);
setLoading(false)
    if ((SECRET === undefined || SECRET === "")) {
      const target =
        (process.env.REACT_APP_FRONTEND_URL || "https://mhcet-reg-dev.hubblehox.ai") +
        `/mhcet/registrations?courseid=${encodeURIComponent(cid)}&coursename=${encodeURIComponent(
          cname
        )}`;

      window.location.href = target;
    }
  }

  }, [window.location.search]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    // 🔹 Construct target URL
    const target = `${REDIRECT_URL}/mhcet/registrations?courseid=${encodeURIComponent(
      courseId
    )}&coursename=${encodeURIComponent(courseName)}`;

    // 🔹 If secret key missing from .env → directly navigate
     if (!key) {
      setError("Please enter the secret key");
      return;
    }
    if (!SECRET) {
      setError("Invalid Secret key. Contact admin.");
      return;
    }

    // Match key
    if (key === SECRET) {
      window.location.href = target;
      return;
    }

    
    // 🔹 Wrong key
    setError("Invalid secret key, please try again");
  };
const handleChange = (e) => {
    let value = e.target.value;
    setKey(value);
    setError("");
  };
   if (loading) {
    return (
      <Box
        sx={{
          height: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f2f2f2",
        }}
      >
        <CircularProgress color="primary" size={60} thickness={5} />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f2f2f2", // soft gray
        p: 2,
      }}
    >
      <Card
        sx={{
          width: 380,
          borderRadius: 4,
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
          backgroundColor: "white",
        }}
      >
        <CardHeader
          title={
            <Typography
              variant="h5"
              fontWeight={600}
              textAlign="center"
              color="primary"
            >
              Secure Access Portal
            </Typography>
          }
          subheader={
            <Typography
              variant="body2"
              color="text.secondary"
              textAlign="center"
              sx={{ mt: 0.5 }}
            >
              Enter your secret key to continue
            </Typography>
          }
        />

        <CardContent>
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Secret Key"
              type={showKey ? "text" : "password"}
              value={key}
              onChange={handleChange}
              error={!!error}
              helperText={error}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    onClick={() => setShowKey(!showKey)}
                    sx={{
                      cursor: "pointer",
                      fontSize: 13,
                      color: showKey ? "primary.main" : "text.secondary",
                      fontWeight: 600,
                    }}
                  >
                    {showKey ? "HIDE" : "SHOW"}
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 3 }}
            />

            <Button
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              type="submit"
              sx={{
                py: 1.3,
                fontWeight: 600,
                borderRadius: 2,
                textTransform: "none",
                fontSize: "1rem",
              }}
            >
              Verify & Continue
            </Button>

            {courseId && courseName && (
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
                align="center"
                mt={2}
              >
                Course: <b>{courseName}</b> (ID: {courseId})
              </Typography>
            )}
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}